<template>
  <div class="header-wrapper">
    <!--顶部导航栏-->
    <div id="header">
      <div class="inner">
        <img class="logo" referrerpolicy="no-referrer" src="~@/assets/layout/logo.png" @click="openInNewPage('/nav')" alt=""/>
        <div class="nav" v-if="!showSearchTextBox">
          <div class="item" :class="navIndex===0?'current':''" @click.stop="openInNewPage('/goods?primaryId=163&secondaryId=250')"> {{ $t('Fabric') }}</div>
          <div class="item" :class="navIndex===1?'current':''" @click.stop="openInNewPage('/designlist?parentId=4&id=125')">{{ $t('Style Library') }}</div>
          <div class="item" :class="navIndex===2?'current':''" @click.stop="openInNewPage('/commonChanel')">{{ $t('Public Showroom') }}</div>
          <div class="item" :class="navIndex===3?'current':''" @click.stop="openInNewPage('/privateChanel')">{{ $t('Private Showroom') }}</div>
        </div>
        <div class="search-text-box" v-if="showSearchTextBox">
          <div class="box">
            <i class="close" @click="closeSearchTextBox"></i>
            <el-autocomplete
              ref="searchInput"
              class="key-word"
              placeholder="Search Community"
              v-model="searchKeyWord"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              @select="handleSelect"
              @keyup.enter.native="handleSearchEnter"
              @keyup.esc.native="closeSearchTextBox">
            </el-autocomplete>
            <i class="button-search" @click="handleSearchText"></i>
          </div>
        </div>
        <div class="tool tool-search-text" @click="openSearchTextBox">
          <el-tooltip content="Search" :visible-arrow="false" placement="bottom" popper-class="header-tool-tips">
            <i class="icon"></i>
          </el-tooltip>
        </div>
        <div class="tool tool-search-image">
          <el-upload :before-upload="handleBeforeUpload" list-type="picture" :show-file-list="false" action="">
            <el-tooltip content="Search by image" :visible-arrow="false" placement="bottom" popper-class="header-tool-tips">
              <i class="icon"></i>
            </el-tooltip>
          </el-upload>
        </div>
        <div class="tool tool-search-advanced" @click="showAdvanceSearch()">
          <el-tooltip content="Advanced Search" :visible-arrow="false" placement="bottom" popper-class="header-tool-tips">
            <i class="icon"></i>
          </el-tooltip>
        </div>
        <advance-search :dialogVisible="showSearchAdvancedDialog" @closeDialog="closeAdvanceSearch" @openLink="openInSelfPage"></advance-search>
        <div class="user" @mouseenter.stop="showUserMenu = true" @mouseleave.stop="showUserMenu = false">
          <img class="avatar" referrerpolicy="no-referrer" :src="avatarUrl" alt=""/>
          <div class="user-menu-wrapper" v-if="showUserMenu">
            <div class="user-menu">
              <div class="header">
                <div class="menu-icon">
                  <div class="icon-wrapper">
                    <img class="icon" referrerpolicy="no-referrer" :src="avatarUrl" alt=""/>
                  </div>
                </div>
                <div class="menu-title">
                  <div class="username">{{ this.userInfo.info.customerName }}</div>
                  <div class="vip">VIP</div>
                </div>
              </div>
              <div class="menu-sep"></div>
              <div class="menu-item" @click="openInNewPage('/favorite?menuType=fabric')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-favorite.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('My Favorites') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/myDesign')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('My Design') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/myOrder')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('My Order') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/myGarmentSample')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('My Development') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/myFabric')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('My Fabric') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/wesAiCreate')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('W&S AI') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/VRChanel')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('VR Showroom') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/privateChanel')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-module.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('Private Showroom') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/history')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-history.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('Browsing History') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/userinfo')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-user.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('Personal Center') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/setting')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-setting.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('Security Setting') }}</div>
              </div>
              <div class="menu-item" @click="openInNewPage('/help')">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-question.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('Help') }}</div>
              </div>
              <div class="menu-sep"></div>
              <div class="menu-item" @click="handleLoginOut">
                <div class="menu-icon">
                  <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-logout.png" alt=""/>
                </div>
                <div class="menu-title">{{ $t('Log Out') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--面包屑-->
    <div v-if="showCrumb" id="crumb">
      <template v-if="searchCrumb.mode">
        <span class="item">{{ $t('Fabric') }}</span><span class="sep">&gt;</span>
        <template v-if="searchCrumb.mode === 'keyword'">
          <span class="item">{{ $t('Search') }}</span><span class="sep">&gt;</span>
          <span class="item">{{ searchCrumb.keyword }}</span>
        </template>
        <template v-else-if="searchCrumb.mode === 'image'">
          <span class="item">{{ $t('Image Search') }}</span>
        </template>
        <template v-else-if="searchCrumb.mode === 'advanced'">
          <span class="item">{{ $t('Advanced Search') }}</span>
        </template>
      </template>
      <template v-else>
        <span class="item">{{ $t('Fabric') }}</span><span class="sep">&gt;</span>
        <template v-if="crumb.level2.name != null"><span class="item">{{ $t(crumb.level2.name) }}</span><span class="sep">&gt;</span></template>
        <template v-if="crumb.level3.name != null"><span class="item">{{ $t(crumb.level3.name) }}</span><span class="sep">&gt;</span></template>
        <template v-if="crumb.level4.name != null"><span class="item">{{ $t(crumb.level4.name) }}</span><span class="sep">&gt;</span></template>
        <template v-if="crumb.level5.name != null"><span class="item">{{ $t(crumb.level5.name) }}</span><span class="sep">&gt;</span></template>
      </template>
    </div>
    <!--面料类别-->
    <div v-if="showCategory" id="category">
      <div class="primary-category">
        <div v-for="(primary, indexPrimary) in categories"
             :class="primary.entity.id === highlightCategoryId.primary ? 'highlight' :''"
             @mouseenter.stop="handleMouseEnterPrimaryCategory(indexPrimary,primary.entity.id)"
             @mouseleave.stop="handleMouseLeavePrimaryCategory(indexPrimary,primary.entity.id)"
             @click="handleClickPrimaryCategory(indexPrimary,primary.entity.id)"
             class="item">
          <div :class="primary.entity.id === currentCategoryId.primary ? 'current' : ''" class="name">{{ $t(primary.entity.alias) }}</div>
          <div class="secondary-category">
            <div class="inner">
              <div v-for="(secondary, indexSecondary) in primary.children"
                   :class="[secondary.entity.id === clickedCategoryId.secondary ? 'highlight':'',
                 secondary.entity.id === currentCategoryId.secondary ? 'current' : '']"
                   @click.stop="handleClickSecondaryCategory(indexPrimary, indexSecondary, primary.entity.id, secondary.entity.id)"
                   class="item">
                {{ $t(secondary.entity.alias) }}
              </div>
            </div>
            <div v-show="showTertiaryCategory" class="tertiary-category">
              <div v-for="(tertiary, index) in tertiaryCategories"
                   @click.stop="handleClickTertiaryCategory(primary.entity.id, tertiary.entity.parentId, tertiary.entity.id)"
                   class="item">
                {{ $t(tertiary.entity.alias) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { picSearch as apiPicSearch, mapImageSearchToProductIds as apiMapImageSearchToProductIds, productDet as apiProductDetails, getProductIdByCode } from '/api/goods'
import { loginOut as apiLogout, getFrontMenu as apiGetCategories, getSuggestKeys } from '/api'
import { mapMutations, mapState } from 'vuex'
import { getStore, removeStore } from '/utils/storage'
import advancedSearch from '/components/advancedSearch'

export default {
  name: 'headers',
  components: {
    advanceSearch: advancedSearch
  },
  props: {
    showCrumb: { type: Boolean, default: true },
    showCategory: { type: Boolean, default: true }
  },
  data () {
    return {
      productData: null,
      avatarUrl: null,
      navIndex: -1,
      showSearchTextBox: false,
      skipNextSearchSubmit: false,
      showUserMenu: false,
      showSearchAdvancedDialog: false,
      categories: [],
      tertiaryCategories: [],
      showTertiaryCategory: false,
      currentCategoryId: {
        primary: null,
        secondary: null,
        tertiary: null
      },
      highlightCategoryId: {
        primary: null
      },
      clickedCategoryId: {
        primary: null,
        secondary: null
      },
      searchKeyWord: null,
      searchCrumb: {
        mode: null,
        keyword: ''
      },
      crumb: {
        level1: {
          name: 'Fabric',
          id: null
        },
        level2: {
          name: null,
          id: null
        },
        level3: {
          name: null,
          id: null
        },
        level4: {
          name: null,
          id: null
        },
        level5: {
          name: null,
          id: null
        }
      }
    }
  },
  async created () {
    this.currentCategoryId.primary = this.$route.query.primaryId
    this.currentCategoryId.secondary = this.$route.query.secondaryId
    this.currentCategoryId.tertiary = this.$route.query.tertiaryId
    if (this.$route.path === '/goods') {
      this.navIndex = 0
    } else if (this.$route.path === '/goodsDetails') {
      this.navIndex = 0
    } else if (this.$route.path === '/welcome') {
      this.navIndex = 0
    }
    // 国际化
    this.$i18n.locale = getStore('language')
    this.avatarUrl = `https://www.ws-showroom.com/image/avatar/` + this.userInfo.info.avatar
    await this.getCategories()
    this.initCrumb()
  },
  mounted () {
    this.token = getStore('token')
    if (this.$route.path === '/userInfo' ||
      this.$route.path === '/myDesign' ||
      this.$route.path === '/comment' ||
      this.$route.path === '/setting' ||
      this.$route.path === '/help' ||
      this.$route.path === '/history') {
      this.showCrumb = false
      this.showCategory = false
    }
  },
  watch: {
    '$route' (to, from) {
      // 路由发生变化页面刷新
      this.$router.go(0)
    }
  },
  computed: {
    ...mapState([
      'login', 'userInfo'
    ])
  },
  methods: {
    ...mapMutations(['ADD_ANIMATION', 'RECORD_USERINFO']),
    openSearchTextBox () {
      this.showSearchTextBox = true
      this.$nextTick(() => {
        this.focusSearchInput()
      })
    },
    closeSearchTextBox () {
      this.showSearchTextBox = false
    },
    focusSearchInput () {
      const ac = this.$refs.searchInput
      if (!ac) return
      // Element UI Autocomplete: prefer public focus() if present; else getInput().focus()
      if (typeof ac.focus === 'function') {
        ac.focus()
      } else if (typeof ac.getInput === 'function') {
        const input = ac.getInput()
        if (input && typeof input.focus === 'function') {
          input.focus()
        }
      }
    },
    handleSearchEnter () {
      // Autocomplete fires @select on keydown.enter before this keyup;
      // skip list submit when select already handled navigation.
      if (this.skipNextSearchSubmit) {
        this.skipNextSearchSubmit = false
        return
      }
      this.handleSearchText()
    },
    handleSearchText () {
      if (this.skipNextSearchSubmit) {
        this.skipNextSearchSubmit = false
        return
      }
      const keyword = String(this.searchKeyWord || '').trim()
      if (!keyword) {
        return
      }
      this.$router.push({
        path: '/goodSearch?r=' + Math.random() + '&cid=' + encodeURIComponent(keyword)
      })
    },
    querySearch (queryString, cb) {
      let param = {
        queryKey: queryString
      }
      let results = []
      getSuggestKeys(param).then(res => {
        if (res.code === 20000) {
          results = res.data
          cb(results)
        }
      })
      // results = [
      //   { 'value': '三全鲜食（北新泾店）' },
      //   { 'value': 'Hot honey 首尔炸鸡（仙霞路）' }
      // ]
      //
      // results = [{'value': 'aaaaaaaaa'}, {'value': 'bbbbbbbb'}]
      // results = [{ value: 'aaaaaaaaa' }, { value: 'bbbbbbbb' }]
    },
    handleSelect (item) {
      // Block the immediate keyup Enter that follows Autocomplete select.
      this.skipNextSearchSubmit = true
      setTimeout(() => {
        this.skipNextSearchSubmit = false
      }, 100)
      const productCode = item && item.value != null ? String(item.value).trim() : ''
      if (!productCode) {
        this.skipNextSearchSubmit = false
        return
      }
      getProductIdByCode({ productCode: productCode }).then(res => {
        if (res.code === 20000 && res.data) {
          this.showSearchTextBox = false
          this.$router.push({
            path: '/goodsDetails?r=' + Math.random() + '&productId=' + res.data
          })
        } else {
          this.skipNextSearchSubmit = false
          this.handleSearchText()
        }
      }).catch(() => {
        this.skipNextSearchSubmit = false
        this.handleSearchText()
      })
    },
    handleBeforeUpload (file) {
      let fileData = new FormData()
      fileData.append('file', file)
      fileData.append('pn', 0)
      fileData.append('rn', 20)
      apiPicSearch(fileData).then((res) => {
        if (res.code !== 20000) {
          this.$message.error(res.message || 'Image search failed')
          return
        }
        const products = apiMapImageSearchToProductIds(res).join(',')
        if (!products) {
          this.$message.info('No similar fabrics found')
          return
        }
        this.$router.push({ path: '/goodSearch?r=' + Math.random() + '&products=' + products })
      }).catch(() => {
        this.$message.error('Image search failed. Please try again.')
      })
      return false
    },
    getTertiaryCategoriesByCategoryId (primaryCategoryId, secondCategoryId) {
      let result = null
      if (primaryCategoryId && secondCategoryId) {
        const primary = this.categories.find(f => f.entity.id === primaryCategoryId)
        if (primary != null && typeof primary.children !== 'undefined' && primary.children != null && primary.children.length > 0) {
          const second = primary.children.find(f => f.entity.id === secondCategoryId)
          if (second != null && typeof second.children !== 'undefined' && second.children != null && second.children.length > 0) {
            result = second.children
          }
        }
      }
      return result
    },
    getTertiaryCategoriesByIndexCategoryId (primaryIndex, secondCategoryId) {
      let result = null
      if (primaryIndex >= 0 && secondCategoryId && this.categories.length > primaryIndex) {
        const primary = this.categories[primaryIndex]
        if (primary != null && typeof primary.children !== 'undefined' && primary.children != null && primary.children.length > 0) {
          const second = primary.children.find(f => f.entity.id === secondCategoryId)
          if (second != null && typeof second.children !== 'undefined' && second.children != null && second.children.length > 0) {
            result = second.children
          }
        }
      }
      return result
    },
    getTertiaryCategoriesByIndex (primaryIndex, secondIndex) {
      let result = null
      if (primaryIndex >= 0 && secondIndex >= 0 && this.categories.length > primaryIndex) {
        const primary = this.categories[primaryIndex]
        if (primary != null && typeof primary.children !== 'undefined' && primary.children != null && primary.children.length > secondIndex) {
          const second = primary.children[secondIndex]
          if (second != null && typeof second.children !== 'undefined' && second.children != null && second.children.length > 0) {
            result = second.children
          }
        }
      }
      return result
    },
    handleMouseEnterPrimaryCategory (index, primaryCategoryId) {
      if (this.highlightCategoryId.primary !== primaryCategoryId) {
        this.highlightCategoryId.primary = primaryCategoryId
        this.showTertiaryCategory = this.getTertiaryCategoriesByIndexCategoryId(index, this.clickedCategoryId.secondary) != null
      }
    },
    handleMouseLeavePrimaryCategory (index, primaryCategoryId) {
      if (this.clickedCategoryId.primary !== primaryCategoryId) {
        if (this.clickedCategoryId.primary != null) {
          this.highlightCategoryId.primary = this.clickedCategoryId.primary
          const tertiaryCategories = this.getTertiaryCategoriesByCategoryId(this.clickedCategoryId.primary, this.clickedCategoryId.secondary)
          if (tertiaryCategories) {
            this.highlightCategoryId.secondary = this.clickedCategoryId.secondary
            this.tertiaryCategories = tertiaryCategories
            this.showTertiaryCategory = true
          } else {
            this.showTertiaryCategory = false
          }
        } else {
          this.highlightCategoryId.primary = null
        }
      }
    },
    handleClickPrimaryCategory (index, primaryCategoryId) {
      if (this.clickedCategoryId.primary !== primaryCategoryId) {
        this.clickedCategoryId.primary = primaryCategoryId
        this.highlightCategoryId.primary = primaryCategoryId
      } else {
        this.clickedCategoryId.primary = null
        this.highlightCategoryId.primary = null
      }
    },
    handleClickSecondaryCategory (primaryIndex, secondaryIndex, primaryCategoryId, secondaryCategoryId) {
      if (this.clickedCategoryId.secondary !== secondaryCategoryId) {
        const categories = this.getTertiaryCategoriesByIndex(primaryIndex, secondaryIndex)
        if (categories != null) {
          this.clickedCategoryId.secondary = secondaryCategoryId
          this.tertiaryCategories = categories
          this.showTertiaryCategory = this.tertiaryCategories != null
        } else {
          this.openInSelfPage(`/goods?primaryId=${primaryCategoryId}&secondaryId=${secondaryCategoryId}`)
          this.currentCategoryId.secondary = secondaryCategoryId
        }
      } else {
        this.clickedCategoryId.secondary = null
        this.showTertiaryCategory = false
      }
    },
    handleClickTertiaryCategory (primaryCategoryId, secondaryCategoryId, tertiaryCategoryId) {
      this.openInSelfPage(`/goods?primaryId=${primaryCategoryId}&secondaryId=${secondaryCategoryId}&tertiaryId=${tertiaryCategoryId}`)
    },
    openInSelfPage (url, type) {
      this.$router.push({
        path: url,
        query: {
          type
        }
      })
    },
    openInNewPage (url) {
      const routeData = this.$router.resolve({
        path: url
      })
      window.open(routeData.href, '_blank')
    },
    getCategories () {
      return apiGetCategories().then(res => {
        this.categories = res
      })
    },
    initCrumb () {
      this.searchCrumb.mode = null
      this.searchCrumb.keyword = ''
      if (this.$route.path === '/goodSearch') {
        const cid = String(this.$route.query.cid || '').trim()
        const products = this.$route.query.products
        const advcid = this.$route.query.advcid
        if (cid) {
          this.searchCrumb.mode = 'keyword'
          this.searchCrumb.keyword = cid
          return
        }
        if (products) {
          this.searchCrumb.mode = 'image'
          return
        }
        if (advcid) {
          this.searchCrumb.mode = 'advanced'
          return
        }
      }
      if (this.currentCategoryId.primary) {
        const primary = this.categories.find(f => f.entity.id === this.currentCategoryId.primary)
        if (primary) {
          this.crumb.level2.name = primary.entity.alias
          if (this.currentCategoryId.secondary) {
            const secondary = primary.children.find(f => f.entity.id === this.currentCategoryId.secondary)
            if (secondary) {
              this.crumb.level3.name = secondary.entity.alias
              if (this.currentCategoryId.tertiary) {
                const tertiary = secondary.children.find(f => f.entity.id === this.currentCategoryId.tertiary)
                if (tertiary) {
                  this.crumb.level4.name = tertiary.entity.alias
                  const productId = this.$route.query.productId
                  if (productId) {
                    apiProductDetails({ params: { productId } }).then(res => {
                      this.crumb.level5.name = res.result.productCode
                    })
                  }
                }
              }
            }
          }
        }
      }
    },
    handleLoginOut () {
      let params = {
        params: {
          token: this.token
        }
      }
      apiLogout(params).then(res => {
        removeStore('buyCart')
        removeStore('commonTools')
        removeStore('token')
        removeStore('userId')
        removeStore('userInfo')
        window.location.href = '/#/home'
      })
    },
    showAdvanceSearch () {
      this.showSearchAdvancedDialog = true
    },
    closeAdvanceSearch () {
      this.showSearchAdvancedDialog = false
    }
  }
}

</script>

<style lang="scss">
/* ::v-deep无效，去除scope。修改element-ui控件样式*/
.header-tool-tips.el-tooltip__popper.is-dark {
  background-color: white !important;
  color: #918CFF !important;
  font-size: 14px !important;
}

#header .key-word .el-input {
  height: 100%;
}

#header .key-word .el-input input {
  border: none;
  height: 100%;
  font-size: max(16px, 0.833vw);
  line-height: 3.5;
  font-weight: 400;
  color: #8C91FF;
  text-align: center;
}

#banner .el-carousel__container {
  height: 100%;
  width: 100%;
}
</style>

<style scoped lang="scss">
.header-wrapper {
  background-color: #F7F8FA;

  #header {
    width: 100%;
    min-width: 1248px;
    height: 3.646vw;
    min-height: 70px;
    background-color: #F3F4FF;

    > .inner {
      width: 83vw;
      min-width: 1248px;
      height: 100%;
      margin: 0 auto;
      padding: 0 20px;
      display: flex;
      align-items: center;

      img.logo {
        width: 4.167vw;
        min-width: 80px;
        cursor: pointer;
      }

      .nav {
        flex: 1;
        display: flex;
        align-items: stretch;
        height: 100%;

        > .item {
          display: inline-block;
          margin-left: max(80px, 4.167vw);
          padding: 0 5px;
          width: auto;
          border-bottom: 2px solid transparent;
          font-size: max(20px, 1.04vw);
          line-height: 3.5;
          color: #79797B;
          font-weight: 500;
          cursor: pointer;
          position: relative;

          &.current, &:hover {
            color: #918CFF;
            border-color: #918CFF;
          }
        }
      }

      .search-text-box {
        flex: 1;
        height: 2.188vw;
        min-height: 42px;
        overflow: hidden;
        padding: 0 max(80px, 4.167vw);
        display: flex;
        justify-content: center;

        .box {
          position: relative;
          width: 47.708vw;
          min-width: 714px;
          background-color: white;
          border-radius: 23.85vw;
          border: 2px solid #8C91FF;
          display: flex;
          align-items: center;

          i.close {
            display: inline-block;
            margin-left: max(20px, 1.042vw);
            width: 1.094vw;
            min-width: 21px;
            height: 1.094vw;
            min-height: 21px;
            background: url("~@/assets/layout/icon/icon-close.png") no-repeat center center;
            background-size: contain;
            cursor: pointer;
          }

          .key-word {
            flex: 1;
            margin: 0 max(30px, 1.563vw);
            height: 1.979vw;
            min-height: 38px;
          }

          i.button-search {
            display: inline-block;
            margin-right: max(20px, 1.042vw);
            width: 1.094vw;
            min-width: 21px;
            height: 1.094vw;
            min-height: 21px;
            background: url("~@/assets/layout/icon/icon-search-highlight.png") no-repeat center center;
            background-size: contain;
            cursor: pointer;
          }
        }
      }

      .tool {
        width: 2.083vw;
        height: 2.083vw;
        min-width: 40px;
        min-height: 40px;
        margin-right: max(20px, 1.042vw);
        text-align: center;
        cursor: pointer;

        i.icon {
          display: inline-block;
          margin-top: 0.26vw;
          width: 1.563vw;
          min-width: 30px;
          height: 1.563vw;
          min-height: 30px;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
        }

        &.tool-search-text {
          i.icon {
            background-image: url("~@/assets/layout/icon/icon-search.png");
          }

          &:hover {
            i.icon {
              background-image: url("~@/assets/layout/icon/icon-search-highlight.png");
            }
          }
        }

        &.tool-search-image {
          i.icon {
            background-image: url("~@/assets/layout/icon/icon-search-image.png");
          }

          &:hover {
            i.icon {
              background-image: url("~@/assets/layout/icon/icon-search-image-highlight.png");
            }
          }
        }

        &.tool-search-advanced {
          i.icon {
            background-image: url("~@/assets/layout/icon/icon-search-advanced.png");
          }

          &:hover {
            i.icon {
              background-image: url("~@/assets/layout/icon/icon-search-advanced-highlight.png");
            }
          }
        }
      }

      .user {
        position: relative;

        .avatar {
          display: inline-block;
          height: 2.083vw;
          width: 2.083vw;
          min-height: 40px;
          min-width: 40px;
          border-radius: max(20px, 1.042vw);
          cursor: pointer;
        }

        .user-menu-wrapper {
          position: absolute;
          z-index: 10;
          width: 10.417vw;
          min-width: 200px;
          left: max(-150px, -7.813vw);
          top: max(20px, 1.563vw);

          .user-menu {
            width: 100%;
            margin-top: max(20px, 1.042vw);
            padding: 12px 0;
            border-radius: 6px;
            background-color: white;

            > .header {
              display: flex;
              height: 2.292vw;
              min-height: 44px;
              width: 100%;
              padding: 0 10px 4px 10px;
              cursor: default;

              .menu-icon {
                margin-right: max(20px, 1.042vw);

                .icon-wrapper {
                  display: inline-block;
                  border-radius: max(16px, 0.833vw);
                  border: 2px solid #918CFF;

                  img.icon {
                    display: inline-block;
                    width: 1.458vw;
                    height: 1.458vw;
                    min-width: 28px;
                    min-height: 28px;
                    border-radius: max(14px, 0.729vw);
                    border: 2px solid white;
                  }
                }
              }

              .menu-title {
                cursor: default;

                .username {
                  font-size: max(14px, 0.729vw);
                  line-height: 1.429;
                  color: #000000;
                  font-weight: 500;
                }

                .vip {
                  font-size: max(12px, 0.625vw);
                  line-height: 1.333;
                  color: #B7BBFD;
                  font-weight: 500;
                }
              }
            }

            .menu-item {
              display: flex;
              align-items: stretch;
              height: 1.563vw;
              min-height: 30px;
              width: 100%;
              padding: 0 max(10px, 0.521vw);
              margin: 2px 0;
              cursor: pointer;

              .menu-icon {
                position: relative;
                display: flex;
                width: 1.667vw;
                min-width: 32px;
                overflow: hidden;
                margin-right: max(20px, 1.042vw);
                text-align: center;
                align-items: center;
                justify-content: center;

                img.icon {
                  position: absolute;
                  left: 7px;
                  display: inline-block;
                  width: 0.938vw;
                  min-width: 18px;
                }
              }

              .menu-title {
                flex: 1;
                height: 1.563vw;
                min-height: 30px;
                line-height: 2.143;
                font-size: max(14px, 0.729vw);
                color: #A6A6A6;
                font-weight: 400;
              }

              &:hover {
                background-color: #F3F4FF;

                .menu-icon {
                  img.icon {
                    left: -100px;
                    filter: drop-shadow(107px 0px 0 #918CFF);
                  }
                }

                .menu-title {
                  color: #918CFF;
                }
              }
            }

            .menu-sep {
              box-sizing: content-box;
              width: 9.375vw;
              min-width: 180px;
              height: 1px;
              background-clip: content-box;
              background-color: #EDECEB;
              padding: max(8px, 0.417vw);
            }
          }
        }
      }
    }
  }

  #crumb {
    display: flex;
    width: 100%;
    height: 3.125vw;
    min-height: 60px;
    //padding-top: max(20px, 1.042vw);
    font-size: max(18px, 0.94vw);
    font-weight: 400;
    color: #918CFF;
    justify-content: center;
    align-items: center;

    .sep {
      padding: 0 0.417vw;
    }
  }

  #category {
    margin: 0 auto;
    width: 65vw;
    min-width: 1248px;
    height: 2.604vw;
    min-height: 50px;

    .primary-category {
      display: flex;
      justify-content: space-between;
      position: relative;

      > .item {
        flex: 0 0 auto;
        height: 2.604vw;
        min-height: 50px;
        width: 9.896vw;
        min-width: 190px;
        padding: max(9px, 0.469vw);
        border-radius: max(5px, 0.260vw);
        cursor: pointer;

        > .name {
          height: 100%;
          width: 100%;
          padding: 0 max(8px, 0.417vw);
          font-size: max(14px, 0.729vw);
          line-height: 2.28;
          font-weight: 700;
          color: #918CFF;
          border-radius: max(5px, 0.260vw);

          //&.current {
          //  background-color: #918CFF;
          //  color: white;
          //}
        }

        &.highlight {
          margin-bottom: 0;
          background-color: white;
          border: 0;
          border-radius: max(5px, 0.260vw) max(5px, 0.260vw) 0 0;
          box-shadow: 1px 5px 9px rgba(0, 0, 0, 0.1);

          > .name {
            background-color: #918CFF;
            color: white;
          }

          .secondary-category {
            visibility: visible;
            box-shadow: 1px 5px 9px rgba(0, 0, 0, 0.1);
          }
        }

        .secondary-category {
          visibility: hidden;
          position: absolute;
          z-index: 100;
          left: 0;
          right: 0;
          top: max(50px, 2.604vw);
          padding: max(6px, 0.313vw) max(9px, 0.469vw);
          background-color: white;
          border-radius: max(5px, 0.260vw);

          > .inner {

            display: flex;
            flex-wrap: wrap;

            > .item {
              flex: 0 0 auto;
              margin: max(3px, 0.156vw) max(20px, 1.042vw) max(3px, 0.156vw) 0;
              height: 1.406vw;
              min-height: 27px;
              padding: 0 max(8px, 0.417vw);
              border-radius: max(5px, 0.260vw);
              font-size: max(14px, 0.729vw);
              line-height: 1.92;
              //color: rgba(196, 210, 255, 1);
              color: #918CFF;
              font-weight: 600;
              cursor: pointer;

              &.highlight, &:hover {
                background-color: #918CFF;
                color: white;
              }
            }
          }

          .tertiary-category {
            margin-top: max(20px, 1.042vw);
            display: flex;
            flex-wrap: wrap;

            > .item {
              flex: 0 0 auto;
              margin: max(3px, 0.156vw) max(20px, 1.042vw) max(3px, 0.156vw) 0;
              height: 1.406vw;
              min-height: 27px;
              padding: 0 max(8px, 0.417vw);
              border-radius: max(5px, 0.260vw);
              font-size: max(14px, 0.729vw);
              line-height: 1.92;
              //color: rgba(196, 210, 255, 1);
              color: #918CFF;
              font-weight: 600;
              cursor: pointer;

              &.highlight, &:hover {
                background-color: #918CFF;
                color: white;
              }
            }
          }
        }

        &:first-child {
          .secondary-category {
            border-top-left-radius: 0;
          }
        }

        &:last-child {
          .secondary-category {
            border-top-right-radius: 0;
          }
        }
      }
    }
  }
}

</style>




// WEBPACK FOOTER //
// fabricHeader.vue?37ddcfbb